import { z } from 'zod'

// ─── Person Update Schema (PUT /person/:id) ────────────────────────────────
// Only organizational profile fields can be updated via the API.
// Entra ID sync fields (email, displayName, status, etc.) are managed by the sync job.

export const personUpdateSchema = z.object({
	contractTypeId: z.uuid().nullable().optional(),
	geoLocationId: z.uuid().nullable().optional(),
	departmentId: z.uuid().nullable().optional(),
	leadershipTypeId: z.uuid().nullable().optional(),
})

export type PersonUpdateInput = z.infer<typeof personUpdateSchema>

// Note: There is no personCreateSchema because persons are created by the Entra sync job,
// not via HTTP endpoints. See EntraSyncService for person creation logic.
